

export const formationDetailSearchEschema = [

{
    id:1,
    name:'text',
    type:'text',
    labelTitle:'Nombre/DNI/Email/Telefono'
},

]